export default __webpack_public_path__ + "static/media/jackpot.b6f65d73.mp3";